import React from 'react';

import { Select } from 'components/shared/Select';

const SelectField = ({
  field,
  helpers,
  onChanged,
  ...restProps
}: { field: any; helpers: any; onChanged: any } & Record<string, any>) => {
  const handleChange = (value: any) => {
    helpers.setValue(value);

    if (onChanged) {
      onChanged(value);
    }
  };

  return <Select {...field} {...restProps} onChange={handleChange} />;
};

export default React.memo(SelectField) as any;
